export const FEDOPS_APP_NAME = 'communities-blog-member-comments-page';
